export const MAX_IMAGE_SIZE = 2_000_000
export const SUPPORTED_IMAGE_TYPES = ['image/jpg', 'image/jpeg', 'image/png']
export const MAX_KNOWLEDGEBASE_FILE_SIZE = 15_000_000
export const MAX_CHAT_FILE_SIZE = 5_000_000
export const MAX_CHAT_ATTACHMENTS = 5
export const MAX_CHAT_IMAGE_SIZE = 7_242_880
export const MAX_CHAT_IMAGES = 10
export const CHAT_IMAGE_MIME_TYPES: Record<string, string> = {
  png: 'image/png',
  jpg: 'image/jpeg',
  jpeg: 'image/jpeg',
  gif: 'image/gif',
  svg: 'image/svg+xml',
  webp: 'image/webp',
}
